"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ValidationErrors = void 0;

var _simpleCustomErrors = _interopRequireDefault(require("simple-custom-errors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ValidationErrors = _simpleCustomErrors["default"].createError('ValidationError', [{
  code: 'ValidationError',
  description: 'Form is invalid',
  params: ['validators']
}]);

exports.ValidationErrors = ValidationErrors;

var Validations = /*#__PURE__*/function () {
  function Validations() {
    _classCallCheck(this, Validations);
  }

  _createClass(Validations, null, [{
    key: "validateArray",
    value: function validateArray() {
      var validationArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (validationArray.length === 0) {
        return true;
      } // Touch all validators, so they get triggered


      validationArray.forEach(function (validator) {
        return validator && validator.$touch && validator.$touch();
      });
      var failedValidators = validationArray.filter(function (validator) {
        return validator && validator.$invalid;
      }, []);

      if (failedValidators.length > 0) {
        throw new ValidationErrors('ValidationError', {
          validators: failedValidators
        });
      }

      return true;
    }
  }]);

  return Validations;
}();

exports["default"] = Validations;
Validations.ValidationErrors = ValidationErrors;